var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var resetters = new Set();
var keyedResetters = new Map();
export var registerReset = function (fn, key) {
    if (key) {
        keyedResetters.set(key, fn);
        return;
    }
    resetters.add(fn);
};
export var resetAllStores = function () {
    __spreadArray(__spreadArray([], __read(keyedResetters.values()), false), __read(resetters), false).forEach(function (reset) {
        try {
            reset();
        }
        catch (error) {
            console.error("Error resetting store", error);
        }
    });
};
